var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.countdown.finished
        ? [
            _c(
              "div",
              {
                staticClass: "sidebarBlock d-flex flex-wrap",
                attrs: { id: "countdown" },
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "text" }, [
                  _c("div", [_vm._v(_vm._s(_vm.counttyp))]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      _vm._s(
                        _vm.$translate("Servershop5::Template.todayAvailable")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "font-weight-bold" }, [
                    _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.countdown.hours) },
                    }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$translate("Servershop5::Template.hours")) +
                        "\n                    "
                    ),
                    _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.countdown.minutes) },
                    }),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$translate("Servershop5::Template.minutes")
                        ) +
                        "\n                "
                    ),
                  ]),
                ]),
              ]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "iconBox" }, [
      _c("i", { staticClass: "icon-truck" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }